import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed } from "vue";
import { isBlank } from "@/utils/string";
import { DecoratedAsset } from "@/types";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetDashboardTab',
  props: {
    asset: null
  },
  setup(__props: any) {

const props = __props as {
  asset: DecoratedAsset;
}



const { asset } = toRefs(props);

const category = computed(() => {
  return asset.value.assetCategory?.name;
});

const type = computed(() => {
  return asset.value.assetType?.name;
});

const manufacturer = computed(() => {
  return asset.value.manufacturer?.name;
});

const model = computed(() => {
  return asset.value.assetModel?.name;
});

const serialNumber = computed(() => {
  return isBlank(asset.value.serialNumber) ? undefined : asset.value.serialNumber;
});

const installationDate = computed(() => {
  const date = asset.value.installationDate;
  return date?.setZone(store.getters.timeZone)?.toISODate();
});

return { __sfc: true,props, asset, category, type, manufacturer, model, serialNumber, installationDate }
}

})